/**
 * Event bus so the axios client / contexts can open the global AuthPromptModal
 * without importing React state.
 */

export type AuthPromptTab = 'signin' | 'signup';

const EVT = 'dashboard:openAuthPrompt';

export function openAuthPrompt(tab: AuthPromptTab = 'signin'): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVT, { detail: { tab } }));
}

export function onAuthPromptOpen(handler: (tab: AuthPromptTab) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const fn = (e: Event) => {
    const tab = (e as CustomEvent).detail?.tab === 'signup' ? 'signup' : 'signin';
    handler(tab);
  };
  window.addEventListener(EVT, fn as EventListener);
  return () => window.removeEventListener(EVT, fn as EventListener);
}
